import { TimeSpan } from 'fitbeat.models';
import { BookingsConfig } from '../../../config';
import { Day, TimeType } from '../../../helpers';
import { IGymTimeSlotsRepository } from '../interfaces';

export const GYM_TIMESLOTS = 'GYM_TIMESLOTS';
export class DbGymTimeSlotsRepository implements IGymTimeSlotsRepository {
  public static testingSet = false;

  constructor(private db: any, private logger: any) {}

  public async createDefaultDoc(): Promise<void> {
    try {
      const days = BookingsConfig.generateDays(DbGymTimeSlotsRepository.testingSet);
      const defaultGymTimeSlots = {
        _id: GYM_TIMESLOTS,
        days,
      };
      await this.db.put(defaultGymTimeSlots);
    } catch (e) {
      if (e.status === 409) {
        this.logger.info(`${GYM_TIMESLOTS} document already exists`);
        return;
      }
      throw e;
    }
  }

  public async getAll(): Promise<Day[]> {
    const docs = await this.db.get(GYM_TIMESLOTS);
    const days: Day[] = docs.days.map((day: Day) => {
      const timeTypes: TimeType[] = day.timeTypes.map((timeTime) => new TimeType(
        new TimeSpan(
          timeTime.timeSpan.start,
          timeTime.timeSpan.end,
        ),
        timeTime.type,
      ));
      return new Day(timeTypes);
    });

    return days;
  }

  public async updateCache(): Promise<void> {
    throw new Error('Method not implemented.');
  }

  public async setOpenAllDayEveryDay(): Promise<void> {
    try {
      const old = await this.db.get(GYM_TIMESLOTS);
      await this.db.remove(old);
    } catch (e) { /* ignore errors when removing old */ }

    const days = BookingsConfig.generate24HourTimeSlots();
    await this.db.put({ _id: GYM_TIMESLOTS, days });
  }
}
